import '../../styles/components/spinners/SpinnerScalingDotRing.css'

export const SpinnerScalingDotRing = () => {
  return (
    <div className="SpinnerScalingDotRing"></div>
  )
}